import { useSoundStore } from '../stores/useSoundStore';

// Đường dẫn tính từ thư mục `public/` của project Vite/CRA.
// Copy 2 file trong `sounds/` của kit này vào `public/sounds/` là chạy được ngay.
const manifest = {
  hover: '/sounds/hover.mp3',
  click: '/sounds/click.mp3',
} as const;

type SoundKey = keyof typeof manifest;

const cache = new Map<SoundKey, HTMLAudioElement>();

/** Gọi 1 lần khi app khởi động (vd. useEffect ở root layout) */
export function preloadSounds() {
  (Object.keys(manifest) as SoundKey[]).forEach((key) => {
    const audio = new Audio(manifest[key]);
    audio.preload = 'auto';
    cache.set(key, audio);
  });
}

/**
 * Trình duyệt chỉ cho phát audio sau một "user gesture" thật sự (click, keydown, touchstart).
 * Hover một mình không được tính là gesture, nên cần "mở khoá" ngay lần tương tác đầu tiên
 * trong phiên -> sau đó hover mới phát tự nhiên được.
 * Gọi 1 lần khi app khởi động, cùng lúc với preloadSounds().
 */
export function unlockAudioOnFirstInteraction() {
  const unlock = () => {
    cache.forEach((a) => {
      a.play()
        .then(() => a.pause())
        .catch(() => {});
      a.currentTime = 0;
    });
    window.removeEventListener('pointerdown', unlock);
  };
  window.addEventListener('pointerdown', unlock, { once: true });
}

export function playSound(key: SoundKey, volumeMultiplier = 1) {
  const { muted, volume } = useSoundStore.getState();
  if (muted) return;

  const base = cache.get(key);
  if (!base) return;

  // clone để nhiều tiếng chồng lên nhau (hover liên tục) không bị cắt cụt tiếng trước
  const node = base.cloneNode(true) as HTMLAudioElement;
  node.volume = Math.min(1, volume * volumeMultiplier);
  node.play().catch(() => {});
}
